import { message } from "antd";

export default function LogoArea() {
  return (
    <div className="App-logo" onClick={() => message.info("Versión 1.2")}>
      <h1 style={{ 
        color: "white", 
        margin: 0, 
        padding: 0,
        fontSize: "clamp(1rem, 2.5vw, 2.2rem)",
        fontWeight: 700,
        whiteSpace: "nowrap",
        lineHeight: 1,
        textAlign: "left"
      }}>
        PREDIVER
      </h1>
    </div>
  );
}